// extracted by mini-css-extract-plugin
export default {"pdfPrinter":"Report_pdfPrinter__worYI","pageBreak":"Report_pageBreak__L1LSR"};